@if (parameterItems()?.length || categoryTitles()?.length) {
  @if (viewType() === 'tab') {
    <!-- side menu -->
    <div class="parameter-view__tab">
      <div class="parameter-view__tab-categories">
        @if (tabTitlesTop()) {
          <ng-template [ngTemplateOutlet]="tabTitlesTop()"></ng-template>
        }
        @if (shouldShowBasicOrAdvancedToggle()) {
          <div class="parameter-view__basicOrAdvanced">
            <mat-button-toggle-group
              [value]="basicOrAdvanced()"
              (change)="onChangeBasicOrAdvanced($event)"
            >
              <mat-button-toggle value="basic">Basic</mat-button-toggle>
              <mat-button-toggle value="advanced">Advanced</mat-button-toggle>
            </mat-button-toggle-group>
          </div>
        }
        <mat-card appearance="outlined">
          <mat-card-content class="parameter-view__card-content">
            @for (parameterItem of parameterItems(); track parameterItem.category.id) {
              <div
                class="parameter-view__tab-category-header"
                [ngClass]="{
                  'category-selected':
                    parameterItem.category.id === computedSelectedCategoryId() &&
                    customCategorySelectedValue() === undefined,
                }"
                (click)="onClickCategory(parameterItem.category.id)"
                matRipple
                [matRippleCentered]="true"
                [attr.data-testid]="'parameter-view-tab-category-' + parameterItem.category.id"
              >
                <div
                  class="parameter-view__tab-category-header-label"
                  [matBadge]="getNumberOfUnsubmittedChanges(parameterItem)"
                  matBadgeOverlap="false"
                  matBadgeSize="small"
                  matBadgeColor="accent"
                >
                  {{ parameterItem.category.name }}
                </div>
              </div>
            }
            @if (categoryTitles()?.length) {
              @for (categoryTitle of categoryTitles(); track categoryTitle.value) {
                <div
                  class="parameter-view__tab-category-header"
                  [ngClass]="{
                    'category-selected': customCategorySelectedValue() === categoryTitle.value,
                  }"
                  (click)="onClickCustomCategory(categoryTitle.value)"
                  matRipple
                  [matRippleCentered]="true"
                  [attr.data-testid]="'parameter-view-tab-category-' + categoryTitle.value"
                >
                  <div
                    class="parameter-view__tab-category-header-label"
                    [matBadge]="
                      isEditable() ? customCategoryCounts()?.[categoryTitle.value] : undefined
                    "
                    matBadgeOverlap="false"
                    matBadgeSize="small"
                    matBadgeColor="accent"
                  >
                    {{ categoryTitle.label }}
                  </div>
                </div>
              }
            }
          </mat-card-content>
        </mat-card>
      </div>
      <!-- main content -->
      <div class="parameter-view__tab-parameters" [ngStyle]="{ height: height() }">
        @if (tabParametersTop()) {
          <ng-template [ngTemplateOutlet]="tabParametersTop()"></ng-template>
        }
        <div
          class="parameter-view__tab-action"
          [ngClass]="{ 'parameter-view__tab-action-open': isChanged() }"
        >
          @if (showSubmit() && isFilled()) {
            <button
              mat-button
              (click)="onSubmitChanges()"
              [disabled]="isBluetoothLost()"
              [matTooltip]="isBluetoothLost() ? 'Bluetooth connection lost' : ''"
            >
              Submit
              <mat-icon color="accent">send</mat-icon>
            </button>
          }
          @if (showReload()) {
            <button mat-button (click)="onReload()" matTooltip="Reload configuration">
              Reload
              <mat-icon color="accent">refresh</mat-icon>
            </button>
          }
          @if (isChanged() && showClear()) {
            <button mat-button (click)="onClear()" matTooltip="Discard changes">
              Discard changes
              <mat-icon color="warn">close</mat-icon>
            </button>
          }
        </div>

        @let isGps = customCategorySelectedValue() === 'GPS' && categoryTitles()?.length;
        @if (isGps) {
          <div [hidden]="!isGps">
            <ng-template [ngTemplateOutlet]="gpsCategory()"></ng-template>
          </div>
        }

        @let isProximity =
          customCategorySelectedValue() === 'PROXIMITY' && categoryTitles()?.length;
        @if (isProximity) {
          <div [hidden]="!isProximity">
            <ng-template [ngTemplateOutlet]="proximityCategory()"></ng-template>
          </div>
        }
        @let isCommunication =
          customCategorySelectedValue() === 'COMMUNICATION' && categoryTitles()?.length;
        @if (isCommunication) {
          <div [hidden]="!isCommunication">
            <ng-template [ngTemplateOutlet]="communicationCategory()"></ng-template>
          </div>
        }
        @let isCamera = customCategorySelectedValue() === 'CAMERA' && categoryTitles()?.length;
        @if (isCamera) {
          <div [hidden]="!isCamera">
            <ng-template [ngTemplateOutlet]="cameraCategory()"></ng-template>
          </div>
        }
        @let isVf = customCategorySelectedValue() === 'VIRTUAL_FENCE' && categoryTitles()?.length;
        @if (isVf) {
          <div [hidden]="!isVf">
            <ng-template [ngTemplateOutlet]="vfCategory()"></ng-template>
          </div>
        }
        @let isSolexGps = customCategorySelectedValue() === 'SOLEX_GPS' && categoryTitles()?.length;
        @if (isSolexGps) {
          <div [hidden]="!isSolexGps">
            <ng-template [ngTemplateOutlet]="solexGpsCategory()"></ng-template>
          </div>
        }
        @let isBeacon = customCategorySelectedValue() === 'VHF' && categoryTitles()?.length;
        @if (isBeacon) {
          <div [hidden]="!isBeacon">
            <ng-template [ngTemplateOutlet]="beaconCategory()"></ng-template>
          </div>
        }
        @let isVfMap =
          customCategorySelectedValue() === 'VIRTUAL_FENCE_MAP' && categoryTitles()?.length;
        @if (isVfMap) {
          <div [hidden]="!isVfMap" class="h-100">
            <ng-template [ngTemplateOutlet]="vfMapCategory()"></ng-template>
          </div>
        }
        @let isDropOff = customCategorySelectedValue() === 'DROP_OFF' && categoryTitles()?.length;
        @if (isDropOff) {
          <div [hidden]="!isDropOff">
            <ng-template [ngTemplateOutlet]="dropOffCategory()"></ng-template>
          </div>
        }
        @if (!customCategorySelectedValueComputed()) {
          @for (
            subCategory of selectedParameterItem()?.subCategoriesWithParameters;
            track subCategory.name
          ) {
            @if (subCategory.parametersWithData.length) {
              <mat-card appearance="outlined" class="parameter-view__tab-subcategory-card">
                <mat-card-header>
                  <mat-card-title class="parameter-view__tab-subcategory-header">
                    {{ subCategory.name || 'No Subcategory' }}
                  </mat-card-title>
                </mat-card-header>
                <mat-card-content class="parameter-view__tab-items">
                  @for (parameter of subCategory.parametersWithData; track parameter.parameter.id) {
                    <div
                      class="parameter-view__tab-item"
                      [ngClass]="{
                        'empty-value': !parameter.factory?.data && !parameter.user?.data,
                        'changed-parameter': isParameterChanged(parameter.parameter.id),
                        'view-mode': !isEdit(parameter),
                        'differing-row': isParameterDiffering(parameter.parameter.id),
                      }"
                    >
                      <span
                        class="parameter-view__tab-item-parameter"
                        [matTooltip]="parameter?.parameter?.description"
                      >
                        {{ parameter.parameter.name }}
                      </span>
                      <span class="parameter-view__item-value">
                        @if (getValueOverrideByParameterId(parameter.parameter.id)) {
                          <span
                            class="parameter-view__value-override"
                            [matTooltip]="
                              overrideTooltip(
                                parameter.parameter.id,
                                formatOverrideValue(
                                  parameter.parameter,
                                  getValueOverrideByParameterId(parameter.parameter.id)
                                )
                              )
                            "
                            matTooltipClass="multi-device-tooltip"
                          >
                            {{
                              Translator.trimString(
                                formatOverrideValue(
                                  parameter.parameter,
                                  getValueOverrideByParameterId(parameter.parameter.id)
                                ),
                                50
                              )
                            }}
                          </span>
                        } @else {
                          <vectronic-parameter-value
                            [parameterWithData]="parameter"
                            [isEditable]="
                              isEditable() &&
                              parameter.parameter.write &&
                              !isParameterDisabled(parameter.parameter.id)
                            "
                            [collarIds]="collarIds()"
                            [deviceTypeParameterConfigWithAvailableList]="
                              deviceTypeParameterConfigWithAvailableList()
                            "
                            (changeParameterData)="onChangeParameterData($event)"
                            [hideLabel]="true"
                            [showFactory]="showFactory()"
                            [showInfo]="showInfo()"
                            [isEdit]="isEdit(parameter)"
                            (changeEdit)="onChangeEdit(parameter, $event)"
                            [presetPatternParameter]="presetPatternParameter()"
                            [showEditButton]="showEditButton()"
                            (parameterUndo)="onParameterUndo($event)"
                            [hasUndo]="isParameterChanged(parameter.parameter.id)"
                            [showReset]="showResetParameter(parameter.parameter.id)"
                            (resetToFactory)="onResetToFactory(parameter.parameter.id)"
                            [disabled]="
                              isMaxParametersReached() ||
                              isParameterDisabled(parameter.parameter.id)
                            "
                            [showOnlyFactoryLabel]="showOnlyFactoryLabel()"
                            [subsystems]="subsystems()"
                          ></vectronic-parameter-value>
                        }
                      </span>
                      @if (warningByParameterId()?.get(parameter.parameter.id)) {
                        <div
                          class="parameter-view__warning parameter-view__warning--inline"
                          [matTooltip]="warningTooltipByParameterId()?.get(parameter.parameter.id)"
                          matTooltipClass="multi-device-tooltip"
                        >
                          {{ warningByParameterId().get(parameter.parameter.id) }}
                          @if (warningTooltipByParameterId()?.get(parameter.parameter.id)) {
                            <mat-icon class="parameter-view__warning-icon">info_outline</mat-icon>
                          }
                        </div>
                      }
                    </div>
                    @if (getErrorByParameterId(parameter.parameter.id)) {
                      <div class="parameter-view__error">
                        {{ getErrorByParameterId(parameter.parameter.id) }}
                      </div>
                    }
                  }
                </mat-card-content>
              </mat-card>
            }
          }
        }
      </div>
    </div>
  } @else {
    @if (!hideTitle()) {
      <div
        class="parameter-view__grid parameter-view__title"
        [style.grid-template-columns]="accordionGridColumns()"
      >
        <span class="parameter-view__title-item">Name</span>
        @if (columnTitlesFromOverrides().length) {
          @for (columnTitle of columnTitlesFromOverrides(); track columnTitle) {
            <span class="parameter-view__title-item">{{ columnTitle }}</span>
          }
        } @else {
          <span class="parameter-view__title-item">Value</span>
        }
      </div>
    }
    <div
      class="parameter-view__content"
      [ngClass]="{
        'parameter-view__content--fullscreen': isFullScreen(),
        'parameter-view__content--no-scroll': hideScroll(),
      }"
    >
      @for (parameterItem of parameterItems(); track parameterItem.category.id) {
        <div
          class="parameter-view__category-header small-icon-button-wrapper"
          (click)="onClickCategory(parameterItem.category.id)"
        >
          <button mat-icon-button>
            <mat-icon>
              @if (isCategoryExpanded(parameterItem.category.id)) {
                keyboard_arrow_down
              } @else {
                keyboard_arrow_right
              }
            </mat-icon>
          </button>
          {{ parameterItem.category.name }}
        </div>
        @if (isCategoryExpanded(parameterItem.category.id)) {
          @for (subCategory of parameterItem.subCategoriesWithParameters; track subCategory.name) {
            @if (subCategory.parametersWithData.length) {
              <div
                class="parameter-view__subcategory-header small-icon-button-wrapper"
                (click)="onClickSubCategory(subCategory.id)"
              >
                <button mat-icon-button>
                  <mat-icon>
                    @if (isSubCategoryExpanded(subCategory.id)) {
                      keyboard_arrow_down
                    } @else {
                      keyboard_arrow_right
                    }
                  </mat-icon>
                </button>
                {{ subCategory.name || 'No Subcategory' }}
              </div>
              @if (isSubCategoryExpanded(subCategory.id)) {
                @for (parameter of subCategory.parametersWithData; track parameter.parameter.id) {
                  <div
                    class="parameter-view__item parameter-view__grid"
                    [style.grid-template-columns]="accordionGridColumns()"
                    [ngClass]="{
                      'empty-value': !parameter.factory?.data && !parameter.user?.data,
                      'differing-row': isParameterDiffering(parameter.parameter.id),
                    }"
                  >
                    <span
                      class="parameter-view__item-parameter"
                      [matTooltip]="parameter.parameter.description"
                    >
                      {{ parameter.parameter.name }}
                    </span>
                    @if (columnTitlesFromOverrides().length) {
                      @for (columnTitle of columnTitlesFromOverrides(); track columnTitle) {
                        <span class="parameter-view__item-value">
                          @if (
                            getValueOverrideForCollar(columnTitle, parameter.parameter.id);
                            as override
                          ) {
                            <span
                              class="parameter-view__value-override"
                              [matTooltip]="
                                overrideTooltip(
                                  parameter.parameter.id,
                                  formatOverrideValue(parameter.parameter, override)
                                )
                              "
                              matTooltipClass="multi-device-tooltip"
                            >
                              {{
                                Translator.trimString(
                                  formatOverrideValue(parameter.parameter, override),
                                  50
                                )
                              }}
                            </span>
                          } @else {
                            <vectronic-parameter-value
                              [parameterWithData]="parameter"
                              [isEditable]="
                                isEditable() && !isParameterDisabled(parameter.parameter.id)
                              "
                              [showFactory]="showFactory()"
                              [showInfo]="showInfo()"
                              [presetPatternParameter]="presetPatternParameter()"
                              [showEditButton]="showEditButton()"
                              (parameterUndo)="onParameterUndo($event)"
                              [hasUndo]="isParameterChanged(parameter.parameter.id)"
                              [showReset]="showResetParameter(parameter.parameter.id)"
                              (resetToFactory)="onResetToFactory(parameter.parameter.id)"
                              [disabled]="isParameterDisabled(parameter.parameter.id)"
                              [showOnlyFactoryLabel]="showOnlyFactoryLabel()"
                              [subsystems]="subsystems()"
                            ></vectronic-parameter-value>
                          }
                        </span>
                      }
                    } @else {
                      <span class="parameter-view__item-value">
                        @if (getValueOverrideByParameterId(parameter.parameter.id)) {
                          <span
                            class="parameter-view__value-override"
                            [matTooltip]="
                              overrideTooltip(
                                parameter.parameter.id,
                                formatOverrideValue(
                                  parameter.parameter,
                                  getValueOverrideByParameterId(parameter.parameter.id)
                                )
                              )
                            "
                            matTooltipClass="multi-device-tooltip"
                          >
                            {{
                              Translator.trimString(
                                formatOverrideValue(
                                  parameter.parameter,
                                  getValueOverrideByParameterId(parameter.parameter.id)
                                ),
                                50
                              )
                            }}
                          </span>
                        } @else {
                          <vectronic-parameter-value
                            [parameterWithData]="parameter"
                            [isEditable]="
                              isEditable() && !isParameterDisabled(parameter.parameter.id)
                            "
                            [showFactory]="showFactory()"
                            [showInfo]="showInfo()"
                            [presetPatternParameter]="presetPatternParameter()"
                            [showEditButton]="showEditButton()"
                            (parameterUndo)="onParameterUndo($event)"
                            [hasUndo]="isParameterChanged(parameter.parameter.id)"
                            [showReset]="showResetParameter(parameter.parameter.id)"
                            (resetToFactory)="onResetToFactory(parameter.parameter.id)"
                            [disabled]="isParameterDisabled(parameter.parameter.id)"
                            [showOnlyFactoryLabel]="showOnlyFactoryLabel()"
                            [subsystems]="subsystems()"
                          ></vectronic-parameter-value>
                        }
                      </span>
                    }
                  </div>
                  @if (warningByParameterId()?.get(parameter.parameter.id)) {
                    <div
                      class="parameter-view__warning"
                      [matTooltip]="warningTooltipByParameterId()?.get(parameter.parameter.id)"
                      matTooltipClass="multi-device-tooltip"
                    >
                      {{ warningByParameterId().get(parameter.parameter.id) }}
                      @if (warningTooltipByParameterId()?.get(parameter.parameter.id)) {
                        <mat-icon class="parameter-view__warning-icon">info_outline</mat-icon>
                      }
                    </div>
                  }
                  @if (getErrorByParameterId(parameter.parameter.id)) {
                    <div class="parameter-view__error">
                      {{ getErrorByParameterId(parameter.parameter.id) }}
                    </div>
                  }
                }
              }
            }
          }
        }
      }
    </div>
  }
}
